/**
 * @file NoticeEvents.ts
 * @description 需要向用户展示通知的事件名称。
 * 设备族通知事件应使用集中事件名，与 ReportEvents 分离便于 Web 层统一监听。
 */

export const NoticeEvents = {
  CfgChanged: 'notice:Cfg_Changed',
  DpiChanged: 'notice:Dpi_Changed',
  RTChanged: 'notice:RT_Changed',
  BrightnessChanged: 'notice:Brightness_Changed',
  SpeedChanged: 'notice:Speed_Changed',
  /** 鼠标回报率变更通知 */
  ReportRateChanged: 'notice:ReportRate_Changed',
  /** 鼠标按键扫描率变更通知 */
  ScanRateChanged: 'notice:ScanRate_Changed',
} as const

export type NoticeEventName = (typeof NoticeEvents)[keyof typeof NoticeEvents]
